import styled from 'styled-components';

export const TextContainer = styled.div`
  text-decoration: none;
  color: ${props => props.theme.colors.black};

  transition-property: color, text-decoration;
  transition: all 300ms;

  &:hover,
  &:focus,
  &:focus-within {
    h3 {
      color: ${props => props.theme.colors.primary};
      text-decoration: underline;
      text-decoration-thickness: 2px;
    }
  }
`;
